module.exports = __webpack_public_path__ + "fad6de03e4d6db94606892f469796d29.svg";